module.exports = __webpack_public_path__ + "static/cpa-2024-banner-mobile-c85686090b5c206a7edf879884218ced.jpg";